
import { defineComponent, computed } from 'vue'
import IconBase from '@/common/components/ui/icons/IconBase.vue'

export default defineComponent({
    name: 'SidebarBaseButton',
    components: {
        IconBase,
    },
    props: {
        href: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const isIcon = computed(() => {
            if (props.icon) {
                return true
            }
            return false
        })

        return { isIcon }
    },
})
